import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import ClassModules from "../modules/index";
import ClassParticipants from "../participants/index";
import TrainingModuleResults from "../results/index";
import CustomTabs from "components/tabs/customTab";
import {
  BookOpen,
  Users,
  BarChart3,
} from "lucide-react";

const TrainingClassTab = ({ recordId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    {
      value: "training-class-modules",
      label: "Modules",
      icon: <BookOpen className="w-4 h-4" />,
      children: <ClassModules classeId={recordId} />,
    },
    {
      value: "training-class-participants",
      label: "Participants",
      icon: <Users className="w-4 h-4" />,
      children: <ClassParticipants classeId={recordId} />,
    },
    {
      value: "training-module-results",
      label: "Results",
      icon: <BarChart3 className="w-4 h-4" />,
      children: <TrainingModuleResults classeId={recordId} />,
    },
  ];

  const tabValues = items.map(item => item.value);

  const pathParts = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(
    tabValues.includes(lastSegment) ? lastSegment : tabValues[0]
  );

  const onChange = (value) => {
    setActiveTab(value);
    navigate(`/console/training-classes/${recordId}/${value}`);
  };

  

  return (
    <div>
      <CustomTabs
        tabs={items}
        height="h-10"
        activeTab={activeTab}
        onChange={onChange}
      />

      <div className="mt-6">
        {items.find(item => item.value === activeTab)?.children}
      </div>
    </div>
  );
};


export default TrainingClassTab;
